import { render, staticRenderFns } from "./addPaymentIAAConfig.vue?vue&type=template&id=31602290&"
import script from "./addPaymentIAAConfig.vue?vue&type=script&lang=js&"
export * from "./addPaymentIAAConfig.vue?vue&type=script&lang=js&"
import style0 from "./addPaymentIAAConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31602290')) {
      api.createRecord('31602290', component.options)
    } else {
      api.reload('31602290', component.options)
    }
    module.hot.accept("./addPaymentIAAConfig.vue?vue&type=template&id=31602290&", function () {
      api.rerender('31602290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addPaymentIAAConfig.vue"
export default component.exports